import { formatPrismicData } from '@monofront/business/utils';
import { IPrismicRichText } from '@monofront/types';
import { SmallCenteredTextProps } from './types';

export const mapSmallCenteredText = ({
  prismicContent,
}: {
  prismicContent: SmallCenteredTextProps;
}): { text: IPrismicRichText } => {
  const { primary } = formatPrismicData(prismicContent);

  return primary;
};
